import { motion } from 'framer-motion'
import AnimatedSection from '../common/AnimatedSection'
import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { leadershipVision } from '../../data/leadershipPageData'

const visionImage = '/assets/leadership-vision.png'

function LeadershipVision() {
  const { label, titleLine1, titleAccent, paragraphs, pillars } = leadershipVision

  return (
    <AnimatedSection className="leadership-vision">
      <div className="container corp-container">
        <div className="leadership-vision__wrap">
          <motion.div
            className="leadership-vision__media"
            initial={{ opacity: 0, x: -32 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.55, ease: 'easeOut' }}
          >
            <img
              src={visionImage}
              alt="Gold Torbit Metals logo overlooking Dubai skyline at sunset"
              loading="lazy"
            />
          </motion.div>

          <div className="leadership-vision__copy">
            <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
            <h2>
              {titleLine1} <span>{titleAccent}</span>
            </h2>
            {paragraphs.map((paragraph) => (
              <p key={paragraph.slice(0, 20)}>{paragraph}</p>
            ))}

            <div className="leadership-vision__pillars" role="list">
              {pillars.map((pillar) => {
                const Icon = pillar.icon
                return (
                  <div className="leadership-vision__pillar" key={pillar.title} role="listitem">
                    <span className="leadership-vision__pillar-icon" aria-hidden="true">
                      <Icon />
                    </span>
                    <span>{pillar.title}</span>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default LeadershipVision
